import { render, staticRenderFns } from "./GoodsPricesDialog.vue?vue&type=template&id=8c8d8cfc&scoped=true&"
import script from "./GoodsPricesDialog.vue?vue&type=script&lang=js&"
export * from "./GoodsPricesDialog.vue?vue&type=script&lang=js&"
import style0 from "./GoodsPricesDialog.vue?vue&type=style&index=0&id=8c8d8cfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8d8cfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c8d8cfc')) {
      api.createRecord('8c8d8cfc', component.options)
    } else {
      api.reload('8c8d8cfc', component.options)
    }
    module.hot.accept("./GoodsPricesDialog.vue?vue&type=template&id=8c8d8cfc&scoped=true&", function () {
      api.rerender('8c8d8cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/components/GoodsPricesDialog.vue"
export default component.exports